import useAxiosPrivate from "./useAxiosPrivate";

const useLocalStorage = () => {
    const axiosPrivate = useAxiosPrivate();
    
    const getSystemSettings = async() => {
        try {
            const res = await axiosPrivate.get('/settings');
            if (res.status === 200) {
                const data = res.data.data;
                localStorage.setItem('organization', JSON.stringify(data.organization));
                localStorage.setItem('pensionFund', JSON.stringify(data.pensionFund));
                localStorage.setItem('system', JSON.stringify(data.system));
                localStorage.setItem('overtimePolicy', JSON.stringify(data.overtimePolicy));
            }
        } catch (error) { console.error("Error fetching system settings:", error) }

        try {
            const res = await axiosPrivate.get('/formula');
            if (res.status === 200) {
                const data = res.data.data;
                localStorage.setItem('formula', JSON.stringify(data));
            }
        } catch (error) { console.error("Error fetching formual settings:", error) }
    };

    return getSystemSettings;
}

export default useLocalStorage;